require('../appKey');
require('./clearSessionService');

angular.module('app.currentUser', [
  'app.appKey',
  'app.currentUser.clearSessionService'
])
  .factory('currentUser', [
    '$http', '$rootScope', 'appKey', 'app.currentUser.clearSessionService', '$q', '$state', '$cookies', 'PRODUCT', 'ENVIRONMENT',
    function ($http, $rootScope, appKey, clearSession, $q, $state, $cookies, PRODUCT, ENVIRONMENT) {
      let user = {
        data_default: {
          iuserid: null,
          first_name: null,
          last_name: null,
          username: null,
          login_name: null,
          is_admin: null,
          country: null,
          billing_error: null,
          syndication_id: null
        },
        data: {},
        last_updated_session: null,
        subscriptions: {
          recurly: [],
          roku: null,
          invalidConversions: [],
        },
        subscription_err: null,
        jwt: null,

        logSessionActivity: function (gameId) {
          return $http.post(window.location.api('/sessions/apikey_activity'), { 'gameId': gameId }).catch(() => {
            deferred.reject({ error: "Failed to log api activity." });
          });;
        },
        set_data: function (data, callback) {
          if (data && data.iuserid) {
            user.data = data;
          } else {
            user.data = angular.copy(user.data_default);
            user.subscriptions.recurly = null;
            user.accessPasses = null;
          }

          user.data.mob = user.data.mob ? moment(`${user.data.mob}-01`).toDate() : user.data.mob;

          if (Array.isArray(user.data.subscriptions) && user.data.subscriptions.length) {
            _.forEach(user.data.subscriptions, (subscription) => {
              if (subscription.IsActive) {
                if (subscription.PlanType == "recurly") {
                  if (!Array.isArray(user.subscriptions.recurly)) {
                    user.subscriptions.recurly = [];
                  }

                  user.subscriptions.recurly.push(
                    {
                      id: subscription.Id,
                      activated_at: subscription.CreatedDate,
                      plan_code: subscription.PlanCode,
                      plan_type: subscription.PlanType,
                      plan_id: subscription.PspId,
                      expires_at: subscription.ExpirationDate,
                      paused: subscription.IsPaused,
                      is_future: subscription.IsFuture,
                      is_renewable: subscription.IsRenewable,
                      current_period_end_date: subscription.CurrentPeriodEndDate,
                      season_id: subscription.SeasonId,
                      type: subscription.Type,
                      teams: subscription.TypeIds,
                      is_active: subscription.IsActive,
                      subscription_upgrades: subscription.subscription_upgrades,
                    }
                  );
                }
                else if (subscription.PlanType == "roku") {
                  user.subscriptions.roku = subscription;
                }
              }
            });
          }

          if (Array.isArray(user.data.access_passes) && user.data.access_passes.length) {
            _.forEach(user.data.access_passes, (accessPass) => {
              if (accessPass.enabled) {
                if (!Array.isArray(user.accessPasses)) {
                  user.accessPasses = [];
                }

                user.accessPasses.push(
                  {
                    id: accessPass.id,
                    enabled: accessPass.enabled,
                    contentName: accessPass.contentName,
                    description: accessPass.description,
                    endDatetime: accessPass.endDatetime,
                    startDatetime: accessPass.startDatetime,
                    type: accessPass.type,
                  }
                );
              }
            });
          }

          if (typeof callback === 'function') {
            callback();
          }
        },
        is_logged_in: function () {
          return !!user.data && !!user.data.iuserid;
        },
        sendRegistrationEmail: (login_name) => {
          "use strict";

          return $http.post(window.location.api('/resend_registration_email'), {
            email: login_name
          });
        },
        login: function (login_name, password) {
          "use strict";

          let deferred = $q.defer();

          $http.post(window.location.api('sessions/api_key'), {
            email: login_name,
            password: password
          }).then(
            (response) => {
              let data = response.data;
              user.set_data();
              appKey.destroy();
              clearSession();

              if (response.status === 401) {
                let error = 'Invalid username or password.';
                let errorType = null;
                let email = null;

                if (data) {
                  if (data.error) error = data.error;
                  if (data.errorType) errorType = data.errorType;
                  if (data.email) email = data.email;
                }
                deferred.reject({
                  error: error,
                  errorType: errorType,
                  login_name: email
                });
              }
              else if (response.status === 403) {
                let error = 'User account not confirmed.';
                let errorType = 'email-confirmation';
                let email = response.data.email;

                deferred.reject({
                  error: error,
                  errorType: errorType,
                  login_name: email
                });
              }
              else {
                if (data && data.api_key) {
                  appKey.set_user_key(data.api_key);
                } else {
                  appKey.set_user_key(null);
                }
                user.retrieve()
                  .then(result => deferred.resolve(result))
                  .catch(() => {
                    deferred.reject({ error: "Failed to retrieve user data." });
                  });
              }
            });

          return deferred.promise;
        },
        logout: function () {
          user.set_data();
          $cookies.remove('prerolls');
          $cookies.remove('postrolls');
          $cookies.remove('gameid');
          return $http.delete(window.location.api('sessions/apikey_activity'))
            .then(() => {
              "use strict";
              appKey.destroy();
            });
        },
        retrieve: function () {
          let deferred = $q.defer();

          user.set_data();
          $http.get(window.location.api('sessions'))
            .then((response) => {
              let data = response.data;
              let status = response.status;

              if (!data || data.error || status !== 200) {

                if (data.error) {
                  if (data.error.lock) {
                    appKey.destroy();
                    $state.go('app.locked', { obj: data.error.lock });
                  }
                }

                deferred.reject();
              } else {
                user.set_data(data);

                deferred.resolve(data);
              }
            });
          return deferred.promise;
        },
        update: function () {
          return $http.get(window.location.api('sessions'))
            .then((response) => {
              let data = response.data;
              if (data.error) {
                alert(data.error);
              } else {
                user.set_data(data);
                //user.checkUserInfo();

                //$rootScope.$broadcast('current_user_updated');
              }
            });
        },
        retrievePlan: function (name, group) {
          let deferred = $q.defer();
          let resolve_now = true;

          switch (name) {
            case 'current_plan':
              if (user.data && user.subscriptions[group] && user.subscriptions[group].plan_code) {
                resolve_now = false;
                $http.get(window.location.api('subscriptions/plans/' + user.subscriptions[group].plan_code))
                  .then(
                    function (response) {
                      let data = response.data;
                      if (data.plan) {
                        user.subscriptions[group].plan = data.plan;
                        $rootScope.$broadcast('current_plan_retrieved', {
                          success: true
                        });
                      }
                      deferred.resolve(data);
                    },
                    /**
                     * @param {HttpResponse} response
                     */
                    (response) => {
                      deferred.reject(response.data);
                    }
                  );
              } else {
                $rootScope.$broadcast('current_plan_retrieved', {
                  success: false
                });
              }
          }

          if (resolve_now) {
            deferred.resolve();
          }

          return deferred.promise;
        },
        get_current_subscriptions: (group_name) => {
          let deferred = $q.defer();
          if (user.is_logged_in()) {
            return $http.get(window.location.api('subscriptions/active/' + group_name)).then(
              response => {
                let data = response.data;

                if (data.error) {
                  user.subscription_err = data.error;
                  deferred.reject();
                } else if (data.subscriptions) {
                  switch (group_name) {
                    case "recurly":
                      user.subscriptions.recurly = [];

                      _.forEach(data.subscriptions, (subscription) => {
                        user.subscriptions.recurly.push(
                          {
                            id: subscription.id,
                            activated_at: subscription.activated_at,
                            plan_code: subscription.plan_code,
                            plan_type: group_name,
                            plan_id: subscription.plan.id,
                            expires_at: subscription.expires_at,
                            paused: subscription.paused,
                            is_future: subscription.state === "future",
                            is_renewable: subscription.plan.is_renewable,
                            current_period_end_date: subscription.current_period_ends_at,
                            season_id: subscription.season_id,
                            type: subscription.subscription_type,
                            teams: subscription.teams,
                            is_active: subscription.state === "active",
                            subscription_upgrades: subscription.subscription_upgrades,
                            state: subscription.state,
                            plan: subscription.plan,
                            uuid: subscription.uuid,
                          }
                        );
                      });
                      break;
                    case "roku":
                      break;
                  }
                  deferred.resolve();
                }
              });
          }
          else {
            deferred.resolve();
          }
          return deferred.promise;
        },
        get_invalid_conversions: function () {
          let deferred = $q.defer();

          if (user.is_logged_in()) {
            return $http.get(window.location.api('htv2020/subscriptions/invalid_plan_conversions')).then(response => {
              let data = response.data;

              if (data) {
                if (data.error) {
                  deferred.reject();
                }
                else {
                  user.subscriptions.invalidConversions = data;
                  deferred.resolve(data);
                }
              }
            });
          }
          else {
            deferred.resolve();
          }
          return deferred.promise;
        },
        reset_password: function (email) {
          return $http.post(window.location.api('sessions/password_reset'), { email: email });
        },
        change_email: (old_email, new_email, current_password) => {
          return $http.post(window.location.api('sessions/change_email_request'), {
            old_email: old_email,
            new_email: new_email,
            current_password: current_password
          });
        },
        save: function (data) {
          if (user.data && user.data.iuserid) {
            return $http.put(window.location.api('sessions/user/' + user.data.iuserid), {
              user: data
            })
              .then(function (response) {
                if (!response.data.error && (parseInt(response.status) === 200)) {
                  user.set_data(response.data);
                }
                return response;
              }, function (response) {
                return response;
              });
          }
          else {
            let deferred = $q.defer();
            deferred.reject({ data: { error: 'Missing user data' } });
            return deferred.promise;
          }
        },
        has_active_subscription: function () {
          return _.filter(user.subscriptions.recurly, function (sub) {
            return sub.is_active === true && !sub.paused && !sub.is_future;
          }).length > 0;
        },
        hasAccessPass: function () {
          return _.filter(user.accessPasses, function (pass) {
            return pass.enabled === true;
          }).length > 0;
        },
        has_access: function () {
          return user.data && (user.data.is_admin || (user.has_active_subscription() || user.hasAccessPass()));
        },
        is_pass_holder: () => {
          return user.data && user.data.access && user.data.access.length;
        },
        checkUsername: function (username) {
          return $http.get(window.location.api('check_username/' + username));
        },
        subscriptionStatus: (subscription) => {
          if (user.data) {
            if (user.data.billing_error) {
              return 'billing_error';
            } else {
              return subscription.state;
            }
          }

          return null
        },
        isAdmin: function () {
          return user.data && user.data.is_admin;
        },
        hasAdminFunction: function (func_id) {
          if (user.data) {
            switch (func_id) {
              case 5:
                if (user.data.is_admin) {
                  return true;
                }
                break;
            }

            if (user.data.access && Array.isArray(user.data.access)) {
              let access = user.data.access;

              for (let i = 0; i < access.length; i++) {
                if (func_id === access[i].iaccessfunctionid_fk) {
                  return true;
                }
              }
            }
          }

          return false;
        },
        getFbJwt: function (gameId) {
          "use strict";
          let deferred = $q.defer();

          $http.get(window.location.api('sessions/fbjwt/' + gameId), {}).then(
            (response) => {
              let data = response.data;
              if (response.status === 401) {
                deferred.reject({
                  msg: 'Unable to authenticate for scoreboard control.'
                });
              }
              else {
                user.jwt = data.jwt;
                deferred.resolve();
              }
            });

          return deferred.promise;
        },
        removeFbJwt: () => {
          user.jwt = null;
        },
        getId: () => {
          "use strict";
          if (!user.data) return null;
          return user.data.iuserid;
        },
        getName: () => {
          "use strict";
          if (!user.data) return null;
          return user.data.username || user.data.first_name
        },
        getEmail: () => {
          "use strict";
          if (!user.data) return null;
          return user.data.login_name;
        },

        checkUserInfo: (redirect) => {
          switch (PRODUCT.Code) {
            case 'ahl':
            default:
              return false;
            case 'htv':
              if (!user.data.has_all_acc_info) {
                $state.go('app.accountSettings', angular.isObject(redirect) ? redirect : null);
                return true;
              } else {
                return false;
              }
          }
        },

        serialize_user_data: () => {
          let userData = angular.equals(user.data, {}) || !user.data ? null : user.data;
          let serialized = null;
          if (angular.isObject(userData)) {
            userData = angular.copy(userData);
            serialized = JSON.stringify(userData);
          }
          return serialized;
        },

        //Note moment uses 0-11 for months.
        //format Year, Month, Day, Hour, Minute

        showFreeview: () => {
          let showFreeview = false;
          let currentTime = moment().utc();
          let startDate;
          let endDate;
          if (ENVIRONMENT.production) {
            startDate = moment.utc([2024, 0, 23, 18]); //Tue Jan 23, 1:00:00 PM
            endDate = moment.utc([2024, 0, 28, 10]); //Sun Jan 28, 5:00:00 AM
          } else {
            startDate = moment.utc([2024, 0, 1, 18]);
            endDate = moment.utc([2024, 0, 28, 10]);
          }
          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showFreeview = true;
          }
          return showFreeview;
        },

        showAllStars: () => {
          let showAllStars = false;
          let currentTime = moment().utc();
          let startDate = moment.utc([2024, 1, 1, 12]); //Prod - Thu Feb 1, 7:00:00 AM
          let endDate = moment.utc([2024, 1, 6, 10]); //Prod - Tue Feb 6, 5:00:00 AM
          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showAllStars = true;
          }
          return showAllStars;
        },

        showPromotion: () => {
          let showPromotion = false;
          let currentTime = moment().utc();
          //let startDate = moment.utc([2023, 11, 1, 12]); //staging
          let startDate = moment.utc([2023, 11, 13, 12]); //Prod - Wed Dec 13, 7:00:00 AM
          let endDate = moment.utc([2023, 11, 18, 10]); //Prod - Mon Dec 18, 5:00:00 AM
          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showPromotion = true;
          }
          return showPromotion;
        },

        showBlackFriday: () => {
          let showBlackFriday = false;
          let currentTime = moment().utc();
          //let startDate = moment.utc([2023, 10, 1, 12]); //show now
          let startDate = moment.utc([2023, 10, 24, 12]); //this for prod Fri Nov 24, 7:00:00 AM
          let endDate = moment.utc([2023, 10, 28, 4, 59, 59]); // Mon Nov 27, 11:59:59 PM EST
          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showBlackFriday = true;
          }
          return showBlackFriday;
        },

        showSummer: () => {
          let showSummer = false;
          let currentTime = moment().utc();
          let startDate = moment.utc([2024, 6, 15, 11]); //this for prod Mon July 15, 7:00:00 AM
          //let endDate = moment.utc([2023, 7, 31, 11, 59, 59]); //Thur Aug 31 7:59:59 AM
          if (currentTime.isAfter(startDate)) {
            showSummer = true;
          }
          return showSummer;
        },

        showMidSeason: () => {
          let showMidSeason = false;
          let currentTime = moment().utc();
          let startDate;
          let endDate;
          if (ENVIRONMENT.production) {
            startDate = moment.utc([2024, 0, 8, 12]); //this for prod Mon Jan 8, 7:00:00 AM
            endDate = moment.utc([2024, 2, 18, 10, 59, 59]); //Mon Mar 18, 6:59:59 AM
          } else {
            startDate = moment.utc([2024, 0, 8, 12]);
            endDate = moment.utc([2024, 2, 8, 10, 59, 59]);
          }

          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showMidSeason = true;
          }
          return showMidSeason;
        },

        showFinalPriceDrop: () => {
          let showFinalPriceDrop = false;
          let currentTime = moment().utc();
          let startDate;
          let endDate;
          if (ENVIRONMENT.production) {
            startDate = moment.utc([2024, 2, 18, 11]); //this for prod Mon Mar 18, 7:00:00 AM
            endDate = moment.utc([2024, 3, 22, 10, 59, 59]); //end Mon Apr 22 7:59:59
          } else {
            startDate = moment.utc([2024, 2, 8, 11]);
            endDate = moment.utc([2024, 3, 22, 10, 59, 59]);
          }

          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showFinalPriceDrop = true;
          }
          return showFinalPriceDrop;
        },

        showPlayoffs: () => {
          let showPlayoffs = false;
          let currentTime = moment().utc();
          let startDate;
          if (ENVIRONMENT.production) {
            startDate = moment.utc([2023, 3, 22, 12]); //this for prod Mon Apr 22, 8:00:00 AM
          } else {
            startDate = moment.utc([2024, 3, 16, 12]);
          }
          let endDate = moment.utc([2024, 6, 15, 10, 59, 59]);
          if (currentTime.isAfter(startDate) && currentTime.isBefore(endDate)) {
            showPlayoffs = true;
          }
          return showPlayoffs;
        },


      };
      return user;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/fhApp/currentUser/currentUser.js